export const serviceType = [
  {
    "value": "SERVICE",
    "name": "Service",
    "nameEn": "Service",
    "nameIn": "Layanan",
  }
]